import { ReceiptService } from './services/receipt.service';
import { LoanappService } from './services/loanapp.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SearchPipe } from './search.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { QRCodeModule } from 'angularx-qrcode';

import { FileSaverModule, FileSaverService } from 'ngx-filesaver';

import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { RegisterComponent } from './components/register/register.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ValidateService } from './services/validate.service';
import { AuthService } from './services/auth.service';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { AuthGuard } from './guards/auth.guard';
import { GetdataService } from './services/getdata.service';
import { ErrorpageComponent } from './components/errorpage/errorpage.component';
import { LoanapplicationsComponent } from './components/loanapplications/loanapplications.component';
import { LoanapplicationsdetailsComponent } from './components/loanapplicationsdetails/loanapplicationsdetails.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ReceiptComponent } from './components/receipt/receipt.component';
import { SendCMANotificationComponent } from './components/send-cmanotification/send-cmanotification.component';
import { CmaReportComponent } from './components/cma-report/cma-report.component';
import { CmaAppointmentsComponent } from './components/cma-appointments/cma-appointments.component';
import { CompleteProfileComponent } from './components/complete-profile/complete-profile.component';
import { NewAppointmentsComponent } from './components/new-appointments/new-appointments.component';
import { SubmitedCmaReportsComponent } from './components/submited-cma-reports/submited-cma-reports.component';
import { AsidebarComponent } from './components/asidebar/asidebar.component';
import { FixbarComponent } from './components/fixbar/fixbar.component';
import { TooltipDirective } from './services/tooltip.directive';
import { RecentactivitiesComponent } from './components/recentactivities/recentactivities.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

import { LoanResortsService } from './services/loan-resorts.service';
import { AppovedLoanReportCommodityComponent } from './components/appoved-loan-report-commodity/appoved-loan-report-commodity.component';
import { ApprovedLoanReportUsertypeComponent } from './components/approved-loan-report-usertype/approved-loan-report-usertype.component';
import { ApprovedLoanReportWarehouseComponent } from './components/approved-loan-report-warehouse/approved-loan-report-warehouse.component';
import { ApprovedLoanReportStateComponent } from './components/approved-loan-report-state/approved-loan-report-state.component';

import { CpaReportTatComponent } from './components/cpa-report-tat/cpa-report-tat.component';
import { AllReportsComponent } from './components/all-reports/all-reports.component';
import { AgreementComponent } from './components/agreement/agreement.component';
import { LoanReportBorrorwerLimitComponent } from './components/loan-report-borrorwer-limit/loan-report-borrorwer-limit.component';
import { LoanapplicationreportsComponent } from './components/loanapplicationreports/loanapplicationreports.component';
import { ApprovedloanreportComponent } from './components/approvedloanreport/approvedloanreport.component';
import { BorrwerWiseDataComponent } from './components/borrwer-wise-data/borrwer-wise-data.component';
import { CmadatareportsComponent } from './components/cmadatareports/cmadatareports.component';
import { CmaReportSubmitedComponent } from './components/cma-reports/cma-report-submited/cma-report-submited.component';
import { CmaPendingAppComponent } from './components/cma-reports/cma-pending-app/cma-pending-app.component';
import { CmaTatComponent } from './components/cma-reports/cma-tat/cma-tat.component';
import { CmaReportsService } from './services/cma-reports.service';
import { CmaSiteVisitedComponent } from './components/cma-reports/cma-site-visited/cma-site-visited.component';
import { RepaymentByCommodityComponent } from './components/repayments/repayment-by-commodity/repayment-by-commodity.component';
import { RepaymentByUsertypeComponent } from './components/repayments/repayment-by-usertype/repayment-by-usertype.component';
import { RepaymentByBorrowerComponent } from './components/repayments/repayment-by-borrower/repayment-by-borrower.component';
import { RepaymentByCmaComponent } from './components/repayments/repayment-by-cma/repayment-by-cma.component';
import { LoanRepaymentComponent } from './components/loan-repayment/loan-repayment.component';
import { LoanAgreementforbankComponent } from './components/loan-agreementforbank/loan-agreementforbank.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AllloansComponent } from './components/allloans/allloans.component';
import { SanctionedloansComponent } from './components/sanctionedloans/sanctionedloans.component';
import { RepaymentByWarehouseComponent } from './components/repayments/repayment-by-warehouse/repayment-by-warehouse.component';
import { RepaymentByUserComponent } from './components/repayments/repayment-by-user/repayment-by-user.component';
import { ApprovedInStateComponent } from './components/approved-in-state/approved-in-state.component';
import { ApprovedByCommodityComponent } from './components/approved-by-commodity/approved-by-commodity.component';
import { ApprovedByWarehouseComponent } from './components/approved-by-warehouse/approved-by-warehouse.component';
import { TopBorrowerComponent } from './components/top-borrower/top-borrower.component';
import { OutstandingLoansComponent } from './components/outstanding-loans/outstanding-loans.component';
import { CmaVisitPendingComponent } from './components/cma-reports/cma-visit-pending/cma-visit-pending.component';
import { RepaymentReportComponent } from './components/repayments/repayment-report/repayment-report.component';
import { LimitApplicationsComponent } from './components/limit-applications/limit-applications.component';
import { LimitApplicationDetailsComponent } from './components/limit-application-details/limit-application-details.component';
import { ExportService } from './services/export.service';
import { numberWithCommaService } from './services/numberWithComma.service';
import { EncryptionService } from './services/encryption.service';

import { AuthHttpInterceptor } from './interceptors/auth-http.interceptor';
import { DisbursedLoansComponent } from './components/disbursed-loans/disbursed-loans.component';
import { AllloansViewComponent } from './components/allloansView/allloansView.component';
import { LoanApprovedMscmiscollComponent } from './components/loan-approved-mscmiscoll/loan-approved-mscmiscoll.component';

const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'dashboard',
    component: RecentactivitiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'loanapplications',
    component: LoanapplicationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'loanapplicationdetails',
    component: LoanapplicationsdetailsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'disbursedloans',
    component: DisbursedLoansComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sanctionedloans',
    component: SanctionedloansComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cmaappointments',
    component: CmaAppointmentsComponent,
    canActivate: [AuthGuard],
  },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'receipt', component: ReceiptComponent },
  { path: 'user/loanagreement', component: AgreementComponent },
  {
    path: 'sendnotification',
    component: SendCMANotificationComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'cmareport',
  //   component: CmaReportComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'completeprofile',
    component: CompleteProfileComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'new-cmaappointments',
  //   component: NewAppointmentsComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'recentActivites',
    component: RecentactivitiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'submit-cmaappointments',
    component: SubmitedCmaReportsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'approved-loan-reports-state',
    component: ApprovedLoanReportStateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'approved-loan-reports-state/:state',
    component: ApprovedInStateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'approved-loan-reports-cmdt',
    component: AppovedLoanReportCommodityComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'approved-loan-reports-cmdt/:commodity',
    component: ApprovedByCommodityComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'approved-loan-reports-whr',
    component: ApprovedLoanReportWarehouseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'approved-loan-reports-whr/:warehouse',
    component: ApprovedByWarehouseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cpa-tat',
    component: CpaReportTatComponent,
    canActivate: [AuthGuard],
  },
  { path: 'reports', component: AllReportsComponent, canActivate: [AuthGuard] },
  {
    path: 'loan/usertype',
    component: ApprovedLoanReportUsertypeComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'lar',
    component: LoanapplicationreportsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'loan-approved-msc',
    component: LoanApprovedMscmiscollComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'outstanding-loans',
    component: OutstandingLoansComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'lrbl',
    component: LoanReportBorrorwerLimitComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'lrbl/:borrower',
    component: TopBorrowerComponent,
    canActivate: [AuthGuard],
  },
  { path: 'cma-tat', component: CmaTatComponent, canActivate: [AuthGuard] },
  {
    path: 'cma/appointed',
    component: CmaReportSubmitedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cma/pending',
    component: CmaPendingAppComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cma/visited',
    component: CmaSiteVisitedComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cma/not-visited',
    component: CmaVisitPendingComponent,
    canActivate: [AuthGuard],
  },
  // {
  //   path: 'repayment/commodity',
  //   component: RepaymentByCommodityComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'repayment/borrower',
  //   component: RepaymentByBorrowerComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'repayment/user-type',
  //   component: RepaymentByUsertypeComponent,
  //   canActivate: [AuthGuard],
  // },
  // {
  //   path: 'repayment/cma',
  //   component: RepaymentByCmaComponent,
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'repayment/report',
    component: RepaymentReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'repayment/warehouses',
    component: RepaymentByWarehouseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'repayment/applicants',
    component: RepaymentByUserComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'sanction-consent',
    component: LoanAgreementforbankComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'changepass',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  // { path: '**', component: ErrorpageComponent }
  {
    path: 'loan/repayment',
    component: LoanRepaymentComponent,
    canActivate: [AuthGuard],
  },
  { path: 'allloans', component: AllloansComponent, canActivate: [AuthGuard] },
  {
    path: 'allloans-view',
    component: AllloansViewComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'limitapplications',
    component: LimitApplicationsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'limitapplications/:id',
    component: LimitApplicationDetailsComponent,
    canActivate: [AuthGuard],
  },
];
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    DashboardComponent,
    ErrorpageComponent,
    SearchPipe,
    LoanapplicationsComponent,
    LoanapplicationsdetailsComponent,
    ProfileComponent,
    ReceiptComponent,
    SendCMANotificationComponent,
    CmaReportComponent,
    CmaAppointmentsComponent,
    CompleteProfileComponent,
    NewAppointmentsComponent,
    SubmitedCmaReportsComponent,
    AsidebarComponent,
    FixbarComponent,
    TooltipDirective,
    RecentactivitiesComponent,
    AppovedLoanReportCommodityComponent,
    ApprovedLoanReportUsertypeComponent,
    ApprovedLoanReportWarehouseComponent,
    CpaReportTatComponent,
    AllReportsComponent,
    AgreementComponent,
    LoanReportBorrorwerLimitComponent,
    LoanapplicationreportsComponent,
    ApprovedloanreportComponent,
    BorrwerWiseDataComponent,
    CmadatareportsComponent,
    CmaTatComponent,
    CmaReportSubmitedComponent,
    CmaPendingAppComponent,
    CmaSiteVisitedComponent,
    RepaymentByCommodityComponent,
    RepaymentByUsertypeComponent,
    RepaymentByBorrowerComponent,
    RepaymentByCmaComponent,
    LoanAgreementforbankComponent,
    ChangePasswordComponent,
    LoanRepaymentComponent,
    AllloansComponent,
    AllloansViewComponent,
    DisbursedLoansComponent,
    SanctionedloansComponent,
    ApprovedLoanReportStateComponent,
    RepaymentByWarehouseComponent,
    RepaymentByUserComponent,
    ApprovedInStateComponent,
    ApprovedByCommodityComponent,
    ApprovedByWarehouseComponent,
    TopBorrowerComponent,
    OutstandingLoansComponent,
    CmaVisitPendingComponent,
    RepaymentReportComponent,
    LimitApplicationsComponent,
    LimitApplicationDetailsComponent,
    DisbursedLoansComponent,
    LoanApprovedMscmiscollComponent,
  ],
  imports: [
    FileSaverModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    HttpClientModule,
    NgxPaginationModule,
    RouterModule.forRoot(appRoutes),
    FlashMessagesModule.forRoot(),
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(), // ToastrModule added
    NgxDaterangepickerMd.forRoot(),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    ValidateService,
    AuthService,
    EncryptionService,
    GetdataService,
    AuthGuard,
    LoanappService,
    ReceiptService,
    LoanResortsService,
    CmaReportsService,
    ExportService,
    FileSaverService,
    numberWithCommaService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
